// extracted by mini-css-extract-plugin
export var blue = "_12-h";
export var brand = "_12-d";
export var darkGrey = "_12-g";
export var disabled = "_12-6";
export var disabledSubtle = "_12-7";
export var error = "_12-8";
export var green = "_12-i";
export var grey = "_12-f";
export var icon = "_12-0";
export var inherit = "_12-c";
export var lightGrey = "_12-e";
export var orange = "_12-k";
export var pink = "_12-m";
export var primary = "_12-1";
export var purple = "_12-n";
export var quaternary = "_12-4";
export var quinary = "_12-5";
export var red = "_12-l";
export var secondary = "_12-2";
export var success = "_12-b";
export var tertiary = "_12-3";
export var warning = "_12-9";
export var warningSecondary = "_12-a";
export var white = "_12-o";
export var yellow = "_12-j";